
/***
 * ParallelListFactory 接受的 option 为 parallelResource
 * {
 *  route: {
 *    map: {
 *      路由到资源名的映射  如果路由和资源名相同可不写
 *    }
 *  }
 *  ... 和ListViewFactory相同的字段
 *
 *  parallelResource: [
 *    {
 *      ParallelListFactory负责这部分字段的处理
 *    }
 *  ...
 *  ]
 * }
 * @param option: parallelResource
 * @returns {*}
 * @constructor
 */
import List from '../ListView/list'
import {MODE} from '../../constant'
import PageAdd from '../ListView/add/pageAdd'
import EmbedAdd from '../ListView/add/embedAdd'

export function generateComponent(type, option) {
  return {
    name: 'ParallelListView',
    render (h) {
      let resChild = null
      let Add = null
      switch (option.mode) {
        case MODE.EDIT_IN_DIALOG:
          throw new Error('mode error: not support MODE:EDIT_IN_DIALOG for parallel resource')
          break
        case MODE.EDIT_IN_NEW_PAGE:
          Add = PageAdd
          break
        case MODE.EDIT_IN_TABLE:
          Add = EmbedAdd
          break
      }
      switch (type) {
        case 'list':
          resChild = (
            <List
              class="list-wrapper"
              resourceType="parallel"
              mode={option.mode}
              data={option.data}
              schema={option.schema}
              actions={option.actions}
              hooks={option.hooks}
              options={option.options}
              on-triggerSearch={async params => {
                const loadingInstance = this.$loading({ target: '.list-wrapper' })
                await option.data.fetch.list(this.$store, params)
                loadingInstance.close()
              }}
              on-triggerFetchOne={id => option.data.fetch.one(this.$store, id)}
              on-triggerUpdate={async params => {
                // TODO: after moving 'fetch' action to store, cb is useless
                await option.data.update(this.$store, params.data)
                params.cb && params.cb()
              }}
              on-triggerDelete={async params => {
                // TODO: after moving 'fetch' action to store, cb is useless
                await configs.data.delete(this.$store, params.data)
                params.cb && params.cb()
              }}
              on-addHandle={this.addHandler}
              on-editHandle={this.editHandler}
              on-detailHandle={this.detailHandler}
            />
          )
          break;
        case 'add':
          resChild = (
            <Add
              schema={option.schema}
              data={option.data}
              on-triggerFetchOne={id => option.data.fetch.one(this.$store, id)}
            />
          )
          break
        case 'edit':
          resChild = (
            <Add
              schema={option.schema}
              data={option.data}
              model={option.data.provider.one(this.$store.state)}
              on-triggerFetchOne={id => option.data.fetch.one(this.$store, id)}
            />
          )
          break
        case 'detail':
          resChild = (
            <Add
              schema={option.schema}
              data={option.data}
              model={option.data.provider.one(this.$store.state)}
              isDetail={true}
              on-triggerFetchOne={id => option.data.fetch.one(this.$store, id)}
            />
          )
          break
      }
      return (
        <el-dialog
          title={this.$i18n(option.data.resourceName)}
          width="80%"
          visible={true}
          beforeClose={this.cancel}
          on-before-close={val => console.log('before-close', val)}
        >
          {resChild}
        </el-dialog>
      )
    },
    data: function () {
      return {
        cancelText: this.$i18n('Confirm Cancel ?'),
        confirmText: this.$i18n('Confirm ?'),
        confirming: false
      }
    },
    methods: {
      cancel () {
        this.$confirm(this.cancelText)
          .then(() => this.$router.push(this.$route.path.replace(/\/[^/]*?$/, '')))
          .catch(() => {})
      },
      addHandler() {
        this.$router.push(this.$route.path + 'Add')
      },
      editHandler(query) {
        this.$router.push({
          path: this.$route.path + 'Edit',
          query
        })
      },
      detailHandler(query) {
        this.$router.push({
          path: this.$route.path + 'Detail',
          query
        })
      }
    },
    created() {
      this.$emit('triggerSearch')
    }
  }
}


export default function ParallelListViewFactory(resource) {
  const parallelResource = Array.isArray(resource) ? resource : []
  let parallelComponents = {}
  parallelResource.forEach((item) => {
    parallelComponents = Object.assign({}, parallelComponents, {
      [`${item.data.name}`]: generateComponent('list', item),
      [`${item.data.name}Add`]: generateComponent('add', item),
      [`${item.data.name}Edit`]: generateComponent('edit', item),
      [`${item.data.name}Detail`]: generateComponent('detail', item)
    })
  })
  return parallelComponents
}



// WEBPACK FOOTER //
// ./packages/creator/ParallelListView/index.js